import type { CityConfig } from "../city-template/types";

export const mitchellConfig: CityConfig = {
  city: "Mitchell",
  state: "South Dakota",
  stateAbbr: "SD",
  slug: "mitchell",
  route: "/mitchell",
  title: "Emergency Passport Mitchell, SD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Mitchell, SD — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Mitchell travelers, Davison County families, DWU students, Corn Palace tourists, and central South Dakota residents.",
  h1: "Emergency & Expedited Passport Services in Mitchell, SD",
  heroSubtitle: "Corn Palace festival drawing international visitors and need a renewed passport? Dakota Wesleyan University mission trip departing soon? Davison County agricultural trade show in Germany or Canada? We help Mitchell residents — from DWU students and faculty to ag industry professionals to multi-generational farm families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Iconic%20Corn%20Palace%20building%20in%20Mitchell%20South%20Dakota%20with%20its%20unique%20Moorish%20revival%20architecture%20and%20colorful%20corn%20murals%20decorating%20the%20exterior%20facade%2C%20wide%20angle%20shot%20on%20a%20sunny%20summer%20day%20with%20bright%20blue%20prairie%20sky%2C%20tourists%20gathered%20on%20the%20front%20lawn%2C%20historic%20American%20roadside%20attraction%20atmosphere%2C%20warm%20golden%20afternoon%20light%20illuminating%20the%20decorative%20corn%20panels&width=1800&height=700&seq=mitchell-hero-2026&orientation=landscape",
  heroImageAlt: "The World's Only Corn Palace in Mitchell South Dakota with colorful corn murals on a sunny summer day",
  geoPosition: "43.7094;-98.0299",
  geoPlacename: "Mitchell, South Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located approximately 300 miles northeast of Mitchell via I-90 — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Mitchell", zips: "57301" },
    { name: "Mount Vernon", zips: "57363" },
    { name: "Ethan", zips: "57334" },
    { name: "Parkston", zips: "57366" },
    { name: "Alexandria", zips: "57311" },
    { name: "Plankinton", zips: "57368" },
    { name: "Wessington Springs", zips: "57382" },
    { name: "Woonsocket", zips: "57385" },
    { name: "Dimock", zips: "57331" },
    { name: "Letcher", zips: "57359" },
    { name: "White Lake", zips: "57383" },
    { name: "Corsica", zips: "57328" },
    { name: "Armour", zips: "57313" },
    { name: "Tripp", zips: "57376" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Minneapolis Passport Agency — as fast as 24 hours for Mitchell-area travelers with immediate departures." },
    { icon: "ri-flight-takeoff-line", title: "I-90 Corridor Access", desc: "Mitchell sits directly on I-90 with FSD just 70 miles east serving as the regional air gateway. We coordinate timelines around your connections." },
    { icon: "ri-plant-line", title: "Agricultural Trade Ready", desc: "Davison County farmers and agribusiness professionals traveling to international trade shows, equipment expos, and supplier meetings — we understand the ag calendar." },
    { icon: "ri-building-2-line", title: "DWU & Community Support", desc: "Dakota Wesleyan University mission trips, Corn Palace tourist season international visitors, and Mitchell families — we guide everyone through the passport process." },
  ],
  internalLinks: [
    { name: "Fast passport services in Sioux Falls, SD", route: "/sioux-falls" },
    { name: "Expedited passport in Rapid City, SD", route: "/rapid-city" },
    { name: "Quick passport services in Brookings, SD", route: "/brookings" },
    { name: "Urgent passport services in Huron, SD", route: "/huron" },
    { name: "South Dakota passport services overview", route: "/south-dakota" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Mitchell via secure registered courier with direct access to the Minneapolis Passport Agency at 212 3rd Ave S, Minneapolis. Our registered couriers hand-deliver your documents — meaning you get faster results without the 300-mile drive. Mitchell residents can ship from any UPS Store, FedEx Office, or post office location across Davison County.",
  fpcOfficeDistance: "Serving Mitchell, Mount Vernon, Ethan, Parkston, Alexandria, Plankinton, and all Davison County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Mitchell and Davison County. From the historic downtown district along Main Street to the Corn Palace tourist corridor, from the DWU campus to the surrounding agricultural communities — we serve all of Davison County and adjacent areas. Our courier service eliminates the need to drive five hours to the Minneapolis Passport Agency or wait for a post office appointment.",
  nearbyCitiesIntro: "We serve Mitchell and surrounding communities including Mount Vernon, Ethan, Parkston, Alexandria, Plankinton, Wessington Springs, Woonsocket, and Dimock. We also serve travelers departing from Sioux Falls Regional Airport (FSD) who need expedited passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Mitchell as simple as possible — with the efficiency and reliability DWU students, agribusiness professionals, and Davison County families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Mitchell travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Mitchell travelers encounter unique passport issues — everything from agricultural trade show visa timelines to Corn Palace visitor season international travel. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Mitchell travelers — from DWU students to Davison County farmers to Corn Palace visitors — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Mitchell, SD? Here are the most common ones we hear from Davison County travelers.",
  statePageRoute: "/states/south-dakota",
  statePageName: "South Dakota",
  servicesIntro: "Whether you need a renewal before a Canadian agricultural equipment expo, an emergency passport for a last-minute DWU mission trip, or a first-time passport for a Mitchell family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dps.sd.gov/driver-licensing",
  dmvLabel: "South Dakota DPS Driver Licensing — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Agricultural trade show in Germany in 3 days? DWU mission trip leaving this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Mitchell-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Mitchell residents renew fast — no agency visit required for most renewals. Perfect for Davison County ag professionals, DWU faculty, and Mitchell families preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Mitchell residents through every step — from DWU freshmen to farm families — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your international ag trade show or DWU trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family trip abroad or DWU faculty sabbatical stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Mitchell residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Mitchell agribusiness executives and DWU professors who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Mitchell-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Mitchell SD", description: "Urgent passport processing for Mitchell South Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Mitchell SD", description: "Fast passport renewal for Mitchell South Dakota residents with a previously-issued passport." },
    { name: "First-Time Passport Mitchell SD", description: "New passport application services for Mitchell South Dakota residents applying for their first passport." },
    { name: "Child Passport Mitchell SD", description: "Minor passport services for Mitchell South Dakota families with children under 16." },
    { name: "Name Change Passport Mitchell SD", description: "Passport name correction after marriage, divorce, or legal name changes for Mitchell residents." },
    { name: "Second Passport Mitchell SD", description: "Second passport services for Mitchell agribusiness executives and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Brad S.",
      location: "Farmer, Davison County",
      rating: 5,
      text: "I needed to go to the Agritechnica trade show in Germany on short notice and my passport expired during harvest last year. Fast Passport Center got me renewed in 4 days. Made it to Hannover with time to spare.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Sarah W.",
      location: "DWU Student, Mitchell",
      rating: 5,
      text: "I got accepted to a mission trip to Guatemala with only 2 weeks before departure. I had never had a passport. They walked me through everything and it arrived 5 days before my flight. Amazing service.",
      service: "First-Time Passport",
    },
    {
      name: "The Henderson Family",
      location: "Mitchell",
      rating: 5,
      text: "We planned a family heritage trip to the Netherlands and discovered our teenager's passport was expired. They expedited the renewal and we made our flights with confidence. Would use again in a heartbeat.",
      service: "Child Passport Renewal",
    },
    {
      name: "David M.",
      location: "Ag Equipment Dealer, Mitchell",
      rating: 5,
      text: "Second time using Fast Passport Center for international equipment sourcing trips. The document review is thorough and they understand the ag industry timeline. I won't go anywhere else.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "mitchell-1",
      name: "Mitchell Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 E 5th Ave",
      city: "Mitchell",
      state: "SD",
      zip: "57301",
      phone: "(605) 996-7711",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Mitchell",
      website: "https://tools.usps.com/find-location.htm?location=1368406",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility serving Mitchell and Davison County. Passport photos available. Appointment recommended — walk-in availability is limited especially during tourist season.",
      icon: "ri-mail-line",
    },
    {
      id: "mitchell-2",
      name: "Davison County Clerk of Courts",
      type: "County Clerk Passport Acceptance",
      address: "200 E 4th Ave",
      city: "Mitchell",
      state: "SD",
      zip: "57301",
      phone: "(605) 995-8100",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Davison County Courthouse",
      website: "https://www.davisoncounty.org/",
      websiteLabel: "Davison County",
      notes: "County clerk office offering passport acceptance. Convenient alternative to the post office. Call ahead to confirm clerk availability and document requirements.",
      icon: "ri-government-line",
    },
    {
      id: "mitchell-3",
      name: "Parkston Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 W Main St",
      city: "Parkston",
      state: "SD",
      zip: "57366",
      phone: "(605) 928-7251",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Parkston — 22 miles south",
      website: "https://tools.usps.com/find-location.htm?location=1368435",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for Hutchinson County residents and southern Davison County. Appointment recommended. Limited hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "mitchell-4",
      name: "Wessington Springs Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "110 Main St E",
      city: "Wessington Springs",
      state: "SD",
      zip: "57382",
      phone: "(605) 539-9301",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Wessington Springs — 30 miles northwest",
      website: "https://tools.usps.com/find-location.htm?location=1368565",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for Jerauld County residents. Limited capacity — call ahead to confirm availability.",
      icon: "ri-mail-line",
    },
    {
      id: "mitchell-5",
      name: "Sioux Falls Downtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 S 2nd Ave",
      city: "Sioux Falls",
      state: "SD",
      zip: "57104",
      phone: "(605) 336-3343",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Sioux Falls — 70 miles east via I-90",
      website: "https://tools.usps.com/find-location.htm?location=1368468",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in the region. Full photo services and more appointment availability than smaller rural post offices. Worth the drive for guaranteed service.",
      icon: "ri-mail-line",
    },
    {
      id: "mitchell-6",
      name: "Huron Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "410 Dakota Ave S",
      city: "Huron",
      state: "SD",
      zip: "57350",
      phone: "(605) 352-9261",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Huron — 55 miles north via SD-37",
      website: "https://tools.usps.com/find-location.htm?location=1368378",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for Beadle County and northwest Davison County residents. Passport photos available. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 300 miles to Minneapolis Passport Agency", fpc: "Most Mitchell travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "SD-Specific Guidance", agency: "Generic — no agricultural trade, DWU, or central South Dakota expertise", fpc: "Full agribusiness/DWU/Davison County knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Underestimating Rural Mail Processing Time",
      description: "Mitchell travelers often do not account for additional USPS transit time from rural South Dakota before expedited processing begins. We use overnight shipping to avoid this delay.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Mitchell applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Mitchell pharmacy and retail store photos fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Ag Trade Show Visa Requirements",
      description: "Davison County farmers and ag professionals often do not realize that some countries require a business visa alongside a passport for trade shows. We help identify visa timelines early.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Mitchell travelers booking to Asia, South America, or Europe often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Mitchell clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 300 miles to Minneapolis or wait at a rural post office." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Mitchell?", a: "We offer Mitchell-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Mitchell?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Mitchell post office or Davison County clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Mitchell address." },
    { q: "Where can I get passport acceptance in Mitchell?", a: "Mitchell has passport acceptance at the Main Post Office (200 E 5th Ave) and the Davison County Clerk of Courts (200 E 4th Ave). Nearby options include post offices in Parkston, Wessington Springs, Sioux Falls, and Huron." },
    { q: "How far is the nearest passport agency from Mitchell?", a: "The Minneapolis Passport Agency (212 3rd Ave S, Minneapolis, MN) is approximately 300 miles northeast via I-90. It requires appointments for life-or-death emergencies only. For travel within 3–14 days, our registered courier service is the fastest legally available channel without the five-hour drive." },
    { q: "Can you help with passports for agricultural trade shows?", a: "Yes. We regularly assist Davison County farmers and agribusiness professionals with expedited passports for international trade shows like Agritechnica (Germany), Ag in Motion (Canada), and SIMA (France). We understand the ag calendar and can coordinate processing around show dates." },
    { q: "What documents do Mitchell applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Mitchell-specific checklist." },
    { q: "Can I get a passport photo in Mitchell?", a: "Yes — the Mitchell Main Post Office offers passport photos on-site. Additional photo locations include Lewis Drug, Walmart, and Walgreens. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "What airport should I use for international travel from Mitchell?", a: "Sioux Falls Regional Airport (FSD) is 70 miles east via I-90 with connections to MSP, ORD, and DEN international gateways. Mitchell Municipal Airport (MHE) serves general aviation only." },
    { q: "How do I check my Mitchell passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Mitchell to final return shipping typically matches your chosen speed tier." },
    { q: "Can DWU students get help with mission trip passports?", a: "Yes. Dakota Wesleyan University students participating in international mission trips, study abroad, or service learning programs can use our expedited courier service. We understand nonprofit and university group timelines and can process multiple applications simultaneously." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Mitchell Residents",
    intro: "Mitchell's position along the I-90 corridor as a central South Dakota hub with strong agricultural and tourism roots creates unique passport timing challenges. Here's what Mitchell travelers need to know.",
    cards: [
      {
        icon: "ri-plant-line",
        title: "Agricultural Trade Shows & International Equipment",
        subtitle: "Davison County's ag economy drives global business travel",
        description: "Mitchell and surrounding Davison County host major agricultural operations that regularly send representatives to international trade shows. Agritechnica in Hannover, Germany — the world's largest agricultural machinery exhibition — draws South Dakota farmers and dealers every two years. Canadian farm shows in Regina and Toronto attract Mitchell ag professionals annually. The timeline from decision to departure is often just 3–6 weeks.",
        tip: "Agricultural trade show registration deadlines are firm. Start your passport process the moment you register — not when you book your flight to Frankfurt or Toronto.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "FSD — Sioux Falls Regional Airport",
        subtitle: "Joe Foss Field, 70 miles east of Mitchell via I-90",
        description: "Sioux Falls Regional Airport is the closest commercial airport to Mitchell with daily connections to Minneapolis–St. Paul (MSP), Chicago O'Hare (ORD), and Denver (DEN) — all major international gateway airports. Mitchell travelers typically drive 70 miles east on I-90 to FSD, then connect to their international flight through a major hub.",
        tip: "Factor in the 70-mile drive to FSD plus a domestic connection when calculating your passport timeline. A delayed passport means a missed connection and potentially a missed international flight.",
      },
      {
        icon: "ri-building-2-line",
        title: "Dakota Wesleyan University International Programs",
        subtitle: "DWU mission trips, study abroad, and service learning",
        description: "Dakota Wesleyan University in Mitchell offers international mission trips, service learning programs, and study abroad opportunities to destinations including Guatemala, Costa Rica, and various locations in Africa and Asia. Many DWU students — particularly freshmen and sophomores — apply for their first passports just weeks before program departure dates. The university's smaller size means students receive personalized attention, but the passport timeline is the same as at larger schools.",
        tip: "DWU mission trip leaders should encourage students to apply for passports at least 12 weeks before departure. Expedited courier service can close the gap when that timeline is missed.",
      },
      {
        icon: "ri-road-map-line",
        title: "Corn Palace Tourism & International Visitors",
        subtitle: "World's Only Corn Palace draws visitors from six continents",
        description: "The Corn Palace attracts approximately 500,000 visitors annually — including international tourists from Europe, Asia, and South America. Mitchell residents planning to visit family abroad, participate in international tourism exchanges, or travel to Corn Palace sister-festival events overseas often need expedited passport services. The summer tourist season (June–August) coincides with peak family travel, creating simultaneous passport demand.",
        tip: "Mitchell residents traveling internationally during the summer tourist season should apply 2–3 months in advance if possible. The Corn Palace Festival in late August is a popular time for visiting relatives from overseas.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Mitchell & Cross-Border Canada Travel",
      description: "Mitchell's position on I-90 makes Canadian travel accessible — Regina, Saskatchewan is approximately 550 miles north. Fishing trips, agricultural expos, and cross-border shopping in Manitoba and Saskatchewan create regular passport and passport card demand among Mitchell residents.",
    },
  },
  destinations: {
    title: "Where Mitchell Travelers Go — And Why Passports Get Urgent",
    intro: "Mitchell's unique mix of agricultural trade, university travel, and tourism creates diverse passport needs. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "40%", label: "of Mitchell expedited requests are agricultural trade or equipment-related" },
      { stat: "3–6 Weeks", label: "average lead time from ag trade show registration to international departure" },
      { stat: "Jun–Aug", label: "peak season when Corn Palace tourism, family vacations, and summer ag travel intersect" },
      { stat: "300 Miles", label: "distance Mitchell residents avoid by using our courier instead of driving to the Minneapolis agency" },
    ],
    destinations: [
      { name: "Germany", context: "Agritechnica in Hannover, agricultural machinery trade fairs, DWU German heritage programs", urgency: "Trade show dates fixed — 3–6 weeks advance notice", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Regina and Toronto farm shows, Saskatchewan fishing trips, cross-border equipment sourcing", urgency: "Summer ag show season June–August, passport card popular", icon: "ri-map-pin-2-line" },
      { name: "Guatemala & Costa Rica", context: "DWU mission trips and service learning programs — healthcare, education, community development", urgency: "Spring break and summer program deadlines with 4–8 week notice", icon: "ri-map-pin-2-line" },
      { name: "Netherlands & Denmark", context: "Dutch and Scandinavian agricultural heritage, dairy equipment sourcing, family roots travel", urgency: "Summer heritage trips booked 2–3 months in advance", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Winter getaways from South Dakota cold, Cancun resorts, agricultural conferences in Mexico", urgency: "January–March resort deals booked 3–4 weeks out", icon: "ri-map-pin-2-line" },
      { name: "France", context: "SIMA Paris ag equipment show, DWU French language programs, European tourism connections", urgency: "February SIMA show requires December/January passport processing", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other South Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Mount Rushmore State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Sioux Falls", route: "/sioux-falls" },
      { name: "Rapid City", route: "/rapid-city" },
      { name: "Brookings", route: "/brookings" },
    ],
  },
  photoLocations: [
    { name: "Mitchell Main Post Office", address: "200 E 5th Ave, Mitchell, SD 57301", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Lewis Drug — Mitchell", address: "1300 N Main St, Mitchell, SD 57301", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 9 AM – 6 PM" },
    { name: "Walmart Supercenter — Mitchell", address: "1200 S Burr St, Mitchell, SD 57301", hours: "Daily 7 AM – 11 PM" },
    { name: "Walgreens — Mitchell", address: "1601 N Main St, Mitchell, SD 57301", hours: "Daily 8 AM – 10 PM" },
    { name: "UPS Store — Mitchell", address: "1810 N Sanborn Blvd, Mitchell, SD 57301", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM" },
    { name: "Lewis Drug — Parkston", address: "300 W Main St, Parkston, SD 57366", hours: "Mon–Fri 8 AM – 7 PM, Sat 9 AM – 5 PM" },
    { name: "FedEx Office — Sioux Falls", address: "3400 W 49th St, Sioux Falls, SD 57106", hours: "Mon–Fri 7:30 AM – 9 PM, Sat 9 AM – 6 PM" },
    { name: "Walgreens — Sioux Falls", address: "3100 W 41st St, Sioux Falls, SD 57105", hours: "Daily 8 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Mitchell DPS Driver License Exam Station",
      address: "1305 W Havens Ave, Mitchell, SD 57301",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Driver licenses, REAL ID, written and road tests. Appointment recommended.",
      featured: true,
    },
    {
      name: "Sioux Falls DPS Driver License Exam Station",
      address: "3101 W Russell St, Sioux Falls, SD 57107",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Full-service DPS driver license office serving Minnehaha County. REAL ID available. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "FSD",
      name: "Sioux Falls Regional Airport (Joe Foss Field)",
      distance: "About 70 miles east of Mitchell via I-90",
      address: "2801 N Jaycee Ln, Sioux Falls, SD 57104",
      note: "Primary airport for eastern South Dakota. Daily nonstop connections to MSP, ORD, and DEN — all major international gateways. About a 65-minute drive from Mitchell.",
      flightUrl: "https://www.sfairport.com/",
      flightLabel: "FSD Airport Website",
      featured: true,
    },
    {
      code: "MHE",
      name: "Mitchell Municipal Airport",
      distance: "About 5 miles north of downtown Mitchell",
      address: "40491 254th St, Mitchell, SD 57301",
      note: "General aviation airport only — no commercial passenger service. Used by private and corporate aircraft serving Mitchell-area businesses.",
      flightUrl: "https://www.cityofmitchell.org/airport",
      flightLabel: "Mitchell Municipal Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the South Dakota Department of Health Vital Records. Online, mail, or in-person options available.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through SD Department of Health Vital Records. Required for estate and legal matters.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Davison County Register of Deeds. Certified copies available for name changes and legal purposes.",
      url: "https://www.davisoncounty.org/departments/register-of-deeds",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Davison County Clerk of Courts. Required for name change passport corrections.",
      url: "https://www.davisoncounty.org/departments/clerk-of-courts",
    },
  ],
};